import { FlyoutMenuLink } from './header-secondary-menu';
import { UtilityLink } from './header-utility-menu';

export const montefioreUtilityLeftMenu: UtilityLink[] = [
  {
    text: 'montefiore.patientCare',
    link: {
      href: 'https://www.montefiore.org/patient-care',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.albert',
    link: {
      href: 'https://einsteinmed.edu/',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.childrens',
    link: {
      href: 'https://cham.org/',
      target: '_blank',
    },
  },
];

export const montefioreUtilityRightMenu: UtilityLink[] = [
  {
    text: 'montefiore.mychart',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/mychart',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.payBill',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/patients-visitors/billing-insurance/online-bill-pay',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.forProfessionals',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/for-professionals',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.giving',
    link: {
      href: 'https://montefioreeinstein.org/giving',
      target: '_blank',
    },
  },
];

export const flyoutHeadline: FlyoutMenuLink = {
  text: 'montefiore.patientCare',
  link: {
    href: 'https://montefioreeinstein.org/patient-care',
  },
  showIcon: false,
};

export const flyoutMenu: FlyoutMenuLink[] = [
  {
    text: 'montefiore.careAndServices',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/services',
    },
    showIcon: true,
  },
  {
    text: 'montefiore.patientAndVisitorSupport',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/patients-visitors',
    },
    showIcon: true,
  },
  {
    text: 'montefiore.locations',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/locations',
    },
    showIcon: false,
  },
  {
    text: 'montefiore.forProfessionals',
    link: {
      href: 'https://montefioreeinstein.org/patient-care/for-professionals',
    },
    showIcon: true,
  },
];
